import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import alasql from "alasql";
import BacktestService from "../../service/backtest.service";
import Button from "../parts/Button";
import Risk from "./Create/Risk";
import Universe from "./Create/Universe";
import SelectType from "./Create/SelectType";
import Tuners from "./Create/Tuners";
import CreateFinal from "./Create/Create_final";
// import CompareLite from "./Create/universe_lite/compare_lite";
import ModalComponent from "../../components/common/modal/modal";
// import NewSunburst from "./Create/NewSunburst";
import AnalyzeAnalysis from "./Create/universe_lite/Analyze/analysis";
import createStepTitles from "./create.steps.title";
import UniverseAnalyze from "../pages/Create/Universe.Analyze";
import "./Create.scss";
// import FundTypes from "./Create/FundTypes";
// import Benchmark from './Create/Benchmark'
// import Limits from './Create/Limits_json'
// import Limits_New from './Create/Limits/Limits'
// import Parameters from './Create/Parameters'
// import SunBurstHolder from "./Create/SunBurst";

class Create extends Component {
  _isMounted = false;
  // components = [SelectType, Risk, Tuners, Universe, NewSunburst, CreateFinal];
  components =
    this.props.create_portfolio_type &&
    this.props.create_portfolio_type === "THEME_BASED"
      ? [Risk, Universe]
      : [SelectType, Risk, Tuners, Universe, CreateFinal];
  components_lite_analyze = [SelectType, Universe, AnalyzeAnalysis];

  components_lite_security_universe = [
    SelectType,
    Tuners,
    Universe,
    // NewSunburst,
    CreateFinal,
  ];

  // review portfolio on entering directly from portfolio
  components_direct_review = [
    Tuners,
    Universe,
    // NewSunburst,
    CreateFinal,
  ];
  state = {
    submitted: false,
    isLoad: false,
    error: "",
    steps:
      this.props.create_portfolio_type &&
      this.props.create_portfolio_type === "THEME_BASED"
        ? createStepTitles.create_portfolio_theme_based
        : createStepTitles.curated_portfolio,
    steps_lite_analyze: createStepTitles.analyze_an_existing_portfolio,
    steps_lite_security_universe: createStepTitles.own_security_universe,
    step_direct_review: createStepTitles.step_direct_review,
    step: 0,

    form: {
      portfolio_id: 932,
      scenario_id: "",
      scenario_name: "",
      type: "CURRENT",
      ui_params: {
        overall_focus: [],
        fund_type: [],
        styles: [],
        asset_class: [],
        optimization_params: {},
      },
    },

    steps_rules: {
      step0: {
        data: {},
        selected: "",
        errorMsg: "Select card",
      },
      step1: {
        name: "fund_type",
        data: [],
        errorMsg: "Sum of fund types should equal to 100%",
        totalSum: 100,
        range: 100,
      },
      step2: {
        name: "overall_focus",
        data: [],
        errorMsg: "Please select Asset Classes to achieve 100% minimum.",
        minSum: 100,
        range: 100,
      },
      step3: {
        name: "asset_class",
        data: [],
        errorMsg: "Please select Classifications to achieve 100% minimum.",
        minSum: 0,
        range: 100,
      },
      step4: {
        name: "styles",
        data: [],
        errorMsg: "Please select Strategy to achieve 100% minimum.",
        minSum: 0,
        range: 100,
      },
      step5: {
        name: "optimization_params",
        data: [],
        minSum: 0,
        range: -100,
      },
      step6: {
        data: [],
        minSum: 0,
      },
      step7: {
        data: [],
        minSum: 0,
      },
    },
    stepNavigation: false,
    failedCreatingPortfolio: false,
    my_universe: true
  };

  constructor(props) {
    super(props);

    this.percents = {
      "-100": [],
      25: [],
      50: [],
      100: [],
    };

    for (let i = -100; i <= 100; i++) {
      if ((i) => -100) this.percents["-100"].push(i);
      if (i <= 25) this.percents["25"].push(i);
      if (i <= 50) this.percents["50"].push(i);
      this.percents["100"].push(i);
    }

    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.finish = this.finish.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.changeCheckbox = this.changeCheckbox.bind(this);
    this.setPortfolio = this.setPortfolio.bind(this);

    // reset to initial redux store data
    // props.resetPortfolios();
  }

  componentWillMount() {
    this._isMounted = true;

    if (this.props.direct_review_portfolio) {
      this.props.setPath(["Modify Portfolio"]);
    } else {
      this.props.setPath(["Create Portfolio"]);
    }

    if (this.props.direct_review_portfolio === false) {
      BacktestService.getPredefinedScenarios().then((res) => {
        if (res && this._isMounted) {
          this.renderTab0(res.modelportfolios);
        }
      });
    }
    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
      let my_univ = _user_preferences["my_universe"];
      if(process.env.NODE_ENV !== "production")
          my_univ = true;

      this.setState({
        my_universe: my_univ
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active_optimize_using_myUniverse) {
      // if we selected activ_optimize_using_myUniverse in Analyze > Analysis steps
      // adding more steps to it like tuner,UniverseAnalyze, NewSunburst and createFinal
      let listOfNewSteps = [
        SelectType,
        Universe,
        AnalyzeAnalysis,
        Tuners,
        UniverseAnalyze,
        // NewSunburst,
        CreateFinal,
      ];
      let stepsTitle = createStepTitles.optimize_universe_myUniverse;

      this.components_lite_analyze = listOfNewSteps;
      this.setState({
        steps_lite_analyze: stepsTitle,
      });
    }
    // CIO and theme based flow changes
    if (this.props.create_portfolio_type !== nextProps.create_portfolio_type) {
      this.components =
        nextProps.create_portfolio_type === "THEME_BASED"
          ? [Risk, Universe]
          : [SelectType, Risk, Tuners, Universe, CreateFinal];

      this.setState(
        {
          components:
            nextProps.create_portfolio_type &&
            nextProps.create_portfolio_type === "THEME_BASED"
              ? [Risk, Universe]
              : [SelectType, Risk, Tuners, Universe, CreateFinal],
          steps:
            nextProps.create_portfolio_type &&
            nextProps.create_portfolio_type === "THEME_BASED"
              ? createStepTitles.create_portfolio_theme_based
              : createStepTitles.curated_portfolio,
        },
        () => console.log(this.state, "--------state update------------")
      );
    }
  }
  renderTab0(modelportfolios) {
    const portfolios = [];

    for (let i in modelportfolios) {
      let line = modelportfolios[i];
      let key = -1;

      for (let k in portfolios) {
        // if(portfolios[k].name !=line.investment_objective) continue
        if (portfolios[k].id != line.scenario_id) continue;
        else {
          key = k;
          break;
        }
      }

      if (key > -1) {
        portfolios[key].data.push(line);
      } else {
        portfolios.push({
          name: line.investment_objective,
          id: line.scenario_id,
          data: [line],
        });
      }
    }

    this.props.setModelPortfolios(portfolios);
  }

  resetStep(step) {
    let selected_step = this.state.steps_rules["step" + step];

    selected_step.data = [];

    for (let i in selected_step.noui) {
      let line = selected_step.noui[i];
      line.destroy();
    }

    selected_step.noui = [];

    this.setState(this.state);
  }

  // Events

  changeValue(e, ix) {
    let value = e.target.value;
    this.state.steps_rules["step" + this.state.step].data[ix].value2 = String(
      parseFloat(value) / 100
    );
    this.setState(this.state);
  }

  setPortfolio(e, inv) {
    let portfolios = alasql(
      "SELECT * FROM ? WHERE `scenario_id` = '" + e.target.value + "'",
      [this.state.steps_rules.step0.data[inv]]
    );

    for (let i in this.state.steps_rules) {
      let line = this.state.steps_rules[i];

      Array.isArray(line.data) ? (line.data = []) : null;

      this.setState(this.state);

      if (!line.name || !portfolios[0][line.name]) continue;

      if (line.name == "optimization_params") {
        line.data.push(
          {
            name: "Volatility",
            key: "max_vol",
            decimal: true,
            value: "0",
            value2: (
              parseFloat(portfolios[0][line.name].max_vol) / 100
            ).toFixed(2),
          },
          {
            name: "Return",
            key: "min_return",
            decimal: true,
            value: "0",
            value2: (
              parseFloat(portfolios[0][line.name].min_return) / 100
            ).toFixed(2),
          },
          {
            name: "Maximum limit",
            key: "upper_bounds",
            decimal: true,
            value: "0",
            value2: portfolios[0][line.name].upper_bounds,
          }
        );
      } else {
        line.data = portfolios[0][line.name];
      }
    }

    this.state.form.portfolio_id = e.target.value;

    this.setState(this.state);

    this.forceUpdate();
  }

  changeCheckbox(inv) {
    this.state.steps_rules.step0.selected =
      this.state.steps_rules.step0.selected === inv ? "" : inv;
    if (this.state.steps_rules.step0.selected == "") {
      for (let i in this.state.steps_rules) {
        if (!Array.isArray(this.state.steps_rules[i].data)) continue;
        this.state.steps_rules[i].data = [];
      }
    }
    this.state.form.portfolio_id = 0;
    this.forceUpdate();
  }

  // Navigation
  setStep(step) {
    this.setState({ step }, () =>
      this.props.setCurrentActiveStep(this.state.step)
    );

    //dectivating step link
    if (step == 0) {
      this.setState({
        stepNavigation: false,
      });
    }
  }
  next() {
    let {
      step,
      steps,
      steps_lite_analyze,
      steps_lite_security_universe,
    } = this.state;

    const { analyzeExistingActive } = this.props;
    this.props.setCurrentActiveStep(+this.state.step + 1);

    if (this.props.portfolioActive == false) {
      if (steps.length > +step + 1) {
        this.setState({ step: ++step });
      }

      //step navigation button status
      if (step == 0) {
        this.setState({
          stepNavigation: false,
        });
      } else if (step == steps.length - 1) {
        this.setState({
          stepNavigation: true,
        });
      }
    } else if (analyzeExistingActive) {
      if (steps_lite_analyze.length > +step + 1) {
        this.setState({ step: ++step });
      }

      //step navigation button status
      if (step === 0) {
        this.setState({
          stepNavigation: false,
        });
      } else if (step === steps_lite_analyze.length - 1) {
        this.setState({
          stepNavigation: true,
        });
      }
    } else {
      if (steps_lite_security_universe.length > +step + 1) {
        this.setState({ step: ++step });
      }
      //step navigation button status
      if (step === 0) {
        this.setState({
          stepNavigation: false,
        });
      } else if (step === steps_lite_security_universe.length - 1) {
        this.setState({
          stepNavigation: true,
        });
      }
    }
  }

  prev() {
    if (this.state.step > 0) {
      // this.props.setCurrentActiveStep(--this.state.step);
      this.setState({ step: --this.state.step }, () =>
        this.props.setCurrentActiveStep(this.state.step)
      );
    }
  }

  finish() {
    const {
      steps,
      activePortfolioID,
      portfolioActive,
      analyzeExistingActive,
      securityUniverseActive,
      selected_type,
      absolute_max_vol,
      absolute_min_return,
      absolute_max_beta,
      delete_lite_portfolios,
    } = this.props;
    if (steps.backendParams.asset_class) {
      console.log("asset class is set");
    } else {
      steps.backendParams.asset_class = {};
    }
    var ft = [...steps.backendParams.fund_type];
    var cash = ft.find((x) => x.name.toLowerCase() === "cash");

    var ac = [...steps.backendParams.asset_class];

    var ofo = [...steps.backendParams.overall_focus];
    if (cash) {
      ac.push(cash);
      ofo.push(cash);
    }
    var s = [...steps.backendParams.styles];

    if (cash) {
      var tmp = {};
      tmp["style"] = cash["name"];
      tmp["min"] = cash["min"];
      tmp["max"] = cash["max"];
      tmp["value"] = cash["min"];
      tmp["value2"] = cash["max"];
      s.push(tmp);
    } else {
      cash = { name: "Cash", min: "0", max: "0.0" };

      var tmp = {};
      tmp["style"] = cash["name"];
      tmp["min"] = cash["min"];
      tmp["max"] = cash["max"];
      tmp["value"] = cash["min"];
      tmp["value2"] = cash["max"];
      s.push(tmp);
    }

    //modify min max

    const addMinMax = (data, type) => {
      let modifiedData = [];

      for (let i = 0; i < data.length; i++) {
        let obj = {};
        if (type == "style") {
          obj["name"] = data[i]["style"];
          obj["style"] = data[i]["style"];
        } else {
          obj["name"] = data[i]["name"];
        }
        obj["value"] = data[i]["min"];
        obj["value2"] = data[i]["max"];
        obj["min"] = data[i]["min"];
        obj["max"] = data[i]["max"];

        modifiedData.push(obj);
      }
      return modifiedData;
    };

    let _universeSymbols = [
      ...steps.universe.symbols.map((s) => ({
        symbol: s.symbol,
        val: s.val ? s.val / 100 : null,
      })),
    ].filter((ob) => !steps.universe.deleteSecuritiesList.includes(ob.symbol));

    let _analyze_merged_portfolio = [
      ...steps.universeLite.analyze_merged_portfolio,
    ].filter((ob) => !delete_lite_portfolios.includes(ob.symbol));

    const sendData = {
      optimization_params:
        (absolute_max_vol || absolute_min_return || absolute_max_beta) === true
          ? {
              [selected_type]:
                steps.backendParams.optimization_params[activePortfolioID][
                  selected_type
                ],
              benchmark:
                steps.backendParams.optimization_params[activePortfolioID][
                  "benchmark"
                ],
              upper_bounds:
                steps.backendParams.optimization_params[activePortfolioID][
                  "upper_bounds"
                ],
              absolute_flag: absolute_max_vol
                ? 1
                : absolute_min_return
                ? 2
                : absolute_max_beta
                ? 3
                : 0,
            }
          : {
              ...steps.backendParams.optimization_params[activePortfolioID],
            },
      fund_type: addMinMax(ft),
      asset_class: addMinMax(ac),
      overall_focus: addMinMax(ofo),
      styles: addMinMax(s, "style"), //s,
      // styles: s.map((s1) => ({ ...s1, name: s1.style }))
      // shortlist: [ ...steps.universe.symbols.map(s => ({ symbol: s.symbol, val: s.val })) ],
      // shortlist: portfolioActive ? [ ...steps.universeLite.portfolio.map(s => ({ symbol: s.symbol, val: s.weight/100 })) ] : [ ...steps.universe.symbols.map(s => ({ symbol: s.symbol, val: s.val/100 })).filter(d => d.val !== 0) ],
      shortlist:
        portfolioActive && analyzeExistingActive && delete_lite_portfolios
          ? [
              _analyze_merged_portfolio.map((s) => ({
                symbol: s.symbol,
                val: s.core_allocation ? s.core_allocation / 100 : null,
                original_allocation: s.original_allocation
                  ? s.original_allocation / 100
                  : null,
              })),
            ]
          : portfolioActive && securityUniverseActive
          ? [
              ...steps.universeLite.portfolio.map((s) => ({
                symbol: s.symbol,
                val: s.val ? s.val / 100 : null,
                action: s.action,
                original_allocation: s.initial_allocation
                  ? s.initial_allocation / 100
                  : null,
              })),
            ]
          : _universeSymbols,
      scenario_limits: [...steps.limits.scenario_limits],
      // parameters : [...steps.parameters.selectedItems],
      parameters: [...steps.parameters.pickedParameter],
    };

    this.setState({ submitted: true });

    //condition for client upload portfolio
    // portfolioActive && analyzeExistingActive
    //   ? BacktestService.createClientPortfolio({
    //       portfolio_id: steps.risk.activePortfolioID,
    //       scenario_id: "",
    //       scenario_name: steps.risk.scenarioName,
    //       orig_scenario_id: steps.risk.orig_scenario_id,
    //       client_portfolio_id: steps.universeLite.compare_portfolio_id_analyze,
    //       type: "CURRENT",
    //       ui_params: JSON.stringify(sendData),
    //     })
    //       .then((res) => {
    //         if (res) {
    //           this.setState({ isLoad: false });
    //           if ("scenario_id" in res) {
    //             browserHistory.push("/portfolio/" + res.scenario_id);
    //           }
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err, "---error---");
    //         this.setState({ submitted: false });
    //       })
    //   :

    // ===== ajax_create_portfolio ======

    let client_portfolio_id;

    if (this.props.direct_review_portfolio) {
      client_portfolio_id = this.props.compare_portfolio_id;
    } else {
      client_portfolio_id = steps.universeLite.compare_portfolio_id_analyze;
    }

    let _options = {
      portfolio_id: steps.risk.activePortfolioID,
      scenario_id: "",
      scenario_name: steps.risk.scenarioName,
      type: "CURRENT",
      portfolio_type: "CI",
      ui_params: JSON.stringify(sendData),
      // analyze an existing portfolio parameters
      orig_scenario_id: steps.risk.orig_scenario_id,
      client_portfolio_id: client_portfolio_id,
    };

    if (
      this.props.myClientAnalysePortfolio &&
      this.props.myClientButtonActionType === "analyse"
    ) {
      _options["client_id"] = this.props.client_id;
    }
    BacktestService.createPortfolio({ ..._options })
      .then((res) => {
        if (res && this._isMounted) {
          this.setState({ isLoad: false });
          if ("scenario_id" in res) {
            this.props.resetAbsoluteSwitch();
            browserHistory.push("/portfolio/" + res.scenario_id);
          }
        }
      })
      .catch((err) => {
        console.log(err, "----error------------");
        this.setState({ submitted: false, failedCreatingPortfolio: true });

        setTimeout(
          () => this.setState({ failedCreatingPortfolio: false }),
          5000
        );
      });
  }

  // call back function for child component
  nextStepCallBack = (nextStep, val) => {
    let { step, steps } = this.state;
    if (nextStep) {
      this.setState({ step: val ? step + val : ++step }, () =>
        this.props.setCurrentActiveStep(this.state.step)
      );
    }
  };

  modalEventHandler = (value) => {
    const {
      createPortfolioResetDataAlert,
      setCurrentActiveStep,
      resetDirectReviewPortfolio,
      uri,
    } = this.props;
    if (uri && value) {
      createPortfolioResetDataAlert(false);
      browserHistory.push(uri);

      this.setState({
        step: 0,
      });
      setCurrentActiveStep(0);
      resetDirectReviewPortfolio(false);
    } else if (value) {
      this.setState({
        step: 0,
      });
      setCurrentActiveStep(0);
      createPortfolioResetDataAlert(false);
      resetDirectReviewPortfolio(false);
    }
    createPortfolioResetDataAlert(false);
  };

  StepsList = (steps) => {
    const { step } = this.state;
    return (
      <Fragment>
        {steps.map((v, i) => (
          <li className={step === i ? "active" : null} key={i}>
            <a
              href={"#"}
              data-toggle="tab"
              className="text-uppercase steps__step"
              onClick={() => this.setStep(i)}
            >
              <span className="steps__step-number">
                <span>{i + 1}</span>
              </span>
              <span className="steps__step-desc">{steps[i].title}</span>
            </a>
          </li>
        ))}
      </Fragment>
    );
  };

  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const {
      step,
      steps,
      steps_rules,
      steps_lite_analyze,
      steps_lite_security_universe,
      stepNavigation,
      step_direct_review,
    } = this.state;

    // let progressBar = () => ((100 / this.state.steps.length).toFixed(2) * (this.state.step + 1))

    const {
      activePortfolioID,
      scenarioName,
      benchmark_name,
      securitiesValidToNextStep,
      portfolioActive,
      FundTypeStyleError,
      FundTypeClassificationError,
      FundTypeAssetClassError,
      allocationSumError,
      resetDataAlert,
      securityUniverseActive,
      analyzeExistingActive,
      analyzePortfolio,
      historical_returns_error,
      direct_review_portfolio,
      uri,
    } = this.props;

    // const CurrentStep = ( () => this.components[step])()
    const CurrentStep = (() =>
      direct_review_portfolio
        ? this.components_direct_review[step]
        : portfolioActive && securityUniverseActive
        ? this.components_lite_security_universe[step]
        : portfolioActive
        ? this.components_lite_analyze[step]
        : this.components[step])();

    console.log(
      CurrentStep,
      "----------------create jsx running--------------"
    );
    return (
      <Fragment>
        <div className="page-content">
          <div className="head-section">
            <h1 className="text-uppercase">
              {direct_review_portfolio
                ? "Modify Portfolio"
                : "Create portfolio"}

              {/* <sup>
                <small>
                  {" "}
                  <b>BETA</b>{" "}
                </small>
              </sup> */}
            </h1>
            <ul
              className="steps"
              style={{
                pointerEvents: stepNavigation ? "auto" : "none",
              }}
            >
              {direct_review_portfolio
                ? this.StepsList(step_direct_review)
                : portfolioActive && securityUniverseActive
                ? this.StepsList(steps_lite_security_universe)
                : portfolioActive
                ? this.StepsList(steps_lite_analyze)
                : this.StepsList(steps)}
            </ul>
          </div>

          {/* <div className="page-body"> */}
          <div style={{ padding: "10px 15px 0" }}>
            <div className="step clearfix">
              <ModalComponent
                isOpen={resetDataAlert}
                eventHandler={this.modalEventHandler}
                text={`${
                  uri
                    ? "Abandon the portfolio creation process ?"
                    : "Abandon the portfolio creation process and start over ?"
                }`}
              />
              <CurrentStep
                nextStepCallBack={this.nextStepCallBack}
                previousStep={this.prev}
              />
              {console.log(CurrentStep, "-------current steps-------")}
              <div
                style={{
                  display: this.state.submitted ? "block" : "none",
                  padding: "10px",
                }}
              >
                Your Portfolio Creation Request Is Being Submitted For
                Processing{" "}
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: "18px" }}
                ></i>
              </div>
              {this.state.failedCreatingPortfolio ? (
                <div>Failed to create portfolio. Please try again later.</div>
              ) : null}
              <div
                className="button-group"
                style={{
                  display:
                    (direct_review_portfolio === false &&
                      this.state.step === 0) ||
                    (analyzeExistingActive && this.state.step === 2)
                      ? "none"
                      : "flex",
                }}
              >
                <button
                  onClick={this.prev}
                  className="btn btn-next"
                  disabled={!(step > 0)}
                >
                  <i className="fa fa-angle-left"></i> Back
                </button>
                <Button
                  show={this.state.isLoad}
                  submit={() => {
                    this.finish();
                  }}
                  className="btn btn-next"
                  // disabled={(step + 1) != steps.length || !scenarioName || !activePortfolioID || FundTypeStyleError}
                  disabled={
                    direct_review_portfolio
                      ? scenarioName == "" ||
                        scenarioName == null ||
                        !activePortfolioID ||
                        FundTypeStyleError ||
                        step + 1 != step_direct_review.length
                      : portfolioActive
                      ? // step + 1 != steps_lite.length ||
                        !scenarioName || FundTypeStyleError
                      : // step + 1 != steps.length ||
                        !scenarioName ||
                        !activePortfolioID ||
                        FundTypeStyleError
                  }
                >
                  Create
                </Button>
                <button
                  disabled={
                    direct_review_portfolio
                      ? step + 1 == step_direct_review.length ||
                        !securitiesValidToNextStep ||
                        (step >= 1 && FundTypeStyleError)
                      : portfolioActive && securityUniverseActive
                      ? step + 1 == steps_lite_security_universe.length ||
                        !securitiesValidToNextStep ||
                        (step >= 2 && FundTypeStyleError)
                      : portfolioActive
                      ? step + 1 == steps_lite_analyze.length ||
                        !securitiesValidToNextStep ||
                        (analyzeExistingActive && allocationSumError) ||
                        analyzePortfolio.length == 0 ||
                        historical_returns_error ||
                        (step === 4 && FundTypeStyleError)
                      : // ||
                        // (step >= 4 && FundTypeStyleError) ||
                        // (step >= 2 && portfolioActive && allocationSumError)
                        step + 1 == steps.length ||
                        !activePortfolioID ||
                        !securitiesValidToNextStep ||
                        (step >= 3 && FundTypeStyleError)
                  }
                  // disabled={ (step + 1) == steps.length || !activePortfolioID || !securitiesValidToNextStep || (portfolioActive && allocationSumError)}
                  onClick={this.next}
                  className="btn btn-next"
                >
                  Next <i className="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(
  ({ myClients, create: { steps, ui_params, create_portfolio_type } }) => ({
    ui_params,
    steps,
    activePortfolioID: steps.risk.activePortfolioID,
    scenarioName: steps.risk.scenarioName,
    benchmark_name: steps.risk.benchmark_name,
    securitiesValidToNextStep: steps.universe.securitiesValidToNextStep,
    FundTypeStyleError: steps.fundType.displayStyleError,
    FundTypeClassificationError: steps.fundType.displayClassificationError,
    FundTypeAssetClassError: steps.fundType.displayAssetClassError,
    portfolioActive: steps.universeLite.portfolioActive,
    allocationSumError: steps.universeLite.allocationSumError,
    orig_scenario_id: steps.risk.orig_scenario_id,
    resetDataAlert: steps.resetDataAlert,
    securityUniverseActive: steps.universeLite.securityUniverseActive,
    analyzeExistingActive: steps.universeLite.analyzeExistingActive,
    analyzePortfolio: steps.universeLite.portfolio,
    historical_returns_error: steps.universeLite.historical_returns_error,
    active_optimize_using_myUniverse:
      steps.universeLite.active_optimize_using_myUniverse,
    analyze_merged_portfolio: steps.universeLite.analyze_merged_portfolio,
    direct_review_portfolio: steps.create_review_model.direct_review_portfolio,
    compare_portfolio_id: steps.create_review_model.compare_portfolio_id,
    uri: steps.uri,
    absolute_max_vol: steps.tuners_absolute_selection.absolute_max_vol,
    absolute_min_return: steps.tuners_absolute_selection.absolute_min_return,
    absolute_max_beta: steps.tuners_absolute_selection.absolute_max_beta,
    selected_type: steps.tuners_absolute_selection.selected_type,
    delete_lite_portfolios: steps.universeLite.delete_lite_portfolios,
    myClientAnalysePortfolio: myClients.myClientAnalysePortfolio,
    client_id: myClients.client_id,
    myClientButtonActionType: myClients.myClientButtonActionType,
    create_portfolio_type: create_portfolio_type,
  }),
  (dispatch) => ({
    resetPortfolios: () => dispatch({ type: "RESET_PORTFOLIOS" }),
    setModelPortfolios: (modelportfolios) =>
      dispatch({ type: "SET_PORTFOLIOS", payload: modelportfolios }),
    setCurrentActiveStep: (value) =>
      dispatch({ type: "SET_ACTIVE_STEP_COUNT", payload: value }),
    createPortfolioResetDataAlert: (value) =>
      dispatch({
        type: "SET_CREATE_PORTFOLIO_DATA_RESET_ALERT",
        payload: value,
      }),
    resetDirectReviewPortfolio: (payload) =>
      dispatch({ type: "SET_DIRECT_REVIEW_PORTFOLIO", payload }),

    resetAbsoluteSwitch: () =>
      dispatch({
        type: "RESET_CREATE_STEP_ABSOLUTE_SWITCH_HANDLER",
      }),
  })
)(Create);



// WEBPACK FOOTER //
// ./src/components/pages/Create.jsx